'use client'

import React, { useEffect, useState } from 'react'
import debounce from 'lodash.debounce'

const ScrollVisible = (props: any) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const handleScroll = debounce(() => {
            setIsVisible(window.scrollY > 768)
        }, 20)
        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll()
        return () => {
            handleScroll.cancel()
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <div {...props} hidden={!isVisible} />
    )
}

export default ScrollVisible
